import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const radarChartTool: Tool = {
  id: "radar-chart",
  name: () => m.radar_tool_name(),
  description: () => m.radar_tool_description(),
  icon: "🕸️",
  basePath: "/radar-chart",
  status: "stable",
  tags: [
    "chart",
    "plot",
    "data-visualization",
    "radar-chart",
    "spider-chart",
    "science",
  ],
};
